export const getGeneralState = () => ({
    loading: true,
    formIsValid: false,
    searchedCastelletto: null,
    viewCastellettoTable: false,
    error: null
});

export const getAllPeriodParams = () => ({
    elementType: 'input',
    elementConfig: {
        type: 'checkbox',
        name: 'allPeriod',
        checked: false
    },
    value: 'AllPeriod',
    label: '',
    valid: false,
    touched: false,
    cssClass: 'col-12 col-sm-8 col-md-3',
    validation: {
        required: false
    },
})
export const getDefaultParams = (idCorso) => ({
    idCorso,
    daData: null,
    aData: null
});

export const getSearchParams = (tab) => {

    let json = {
        daData: {
            elementType: 'select',
            elementConfig: {
                options: [],
                disabled: false
            },
            value: '',
            label: 'Da:',
            valid: false,
            touched: false,
            cssClass: 'col-12 col-sm-12 col-md-4 col-lg-2',
            style: {maxWidth: '350px', textTransform: 'capitalize'},
            validation: {
                required: true
            },
            error: 'Selezionare il periodo di competenza per il castelletto'
        },
        aData: {
            elementType: 'select',
            elementConfig: {
                options: [],
                disabled: false
            },
            value: '',
            label: 'A:',
            valid: false,
            touched: false,
            cssClass: 'col-12 col-sm-12 col-md-4 col-lg-2',
            style: {maxWidth: '350px', textTransform: 'capitalize'},
            validation: {
                required: true
            },
            error: 'Selezionare il periodo di competenza per il castelletto'
        }
    }

    if(tab !== 'corso'){
        json.idAnagrafica = {
            elementType: 'select',
            elementConfig: {
                options: []
            },
            value: '',
            label: '',
            valid: false,
            touched: false,
            cssClass: 'col-12 col-sm-12 col-md-6 col-lg-3',
            style: {maxWidth: '350px'},
            validation: {
                required: true
            },
            error: 'Selezionare il periodo di competenza per il castelletto'
        }
    }

    return json
};

export const getXlsSearchParams = () => {

    return {
        individuo: {
            elementType: 'select',
            elementConfig: {
                options: [
                    {
                        displayValue: "Entrambi",
                        value: ""
                    },
                    {
                        displayValue: 'Allievi',
                        value: 'allievi'
                    },
                    {
                        displayValue: 'Docenti',
                        value: 'docenti'
                    }
                ],
                disabled: false
            },
            value: '',
            label: 'Individuo',
            valid: false,
            touched: false,
            cssClass: 'col-12 col-sm-12 col-md-4 col-lg-2',
            style: {maxWidth: '350px', textTransform: 'capitalize'},
            validation: {
                required: true
            },
            error: 'Selezionare il periodo di competenza per il file xls'
        },
        daData: {
            elementType: 'select',
            elementConfig: {
                options: [],
                disabled: false
            },
            value: '',
            label: 'Da:',
            valid: false,
            touched: false,
            cssClass: 'col-12 col-sm-12 col-md-4 col-lg-2',
            style: {maxWidth: '350px', textTransform: 'capitalize'},
            validation: {
                required: true
            },
            error: 'Selezionare il periodo di competenza per il file xls'
        },
        aData: {
            elementType: 'select',
            elementConfig: {
                options: [],
                disabled: false
            },
            value: '',
            label: 'A:',
            valid: false,
            touched: false,
            cssClass: 'col-12 col-sm-12 col-md-4 col-lg-2',
            style: {maxWidth: '350px', textTransform: 'capitalize'},
            validation: {
                required: true
            },
            error: 'Selezionare il periodo di competenza per il castelletto'
        }
    }
};

export const getPdfCalendarioUnicoSearchParams = () => {

    return {
        individuo: {
            elementType: 'select',
            elementConfig: {
                options: [],
                disabled: false
            },
            value: '',
            label: 'Unità Formativa',
            valid: false,
            touched: false,
            cssClass: 'col-12 col-sm-12 col-md-4 col-lg-2',
            style: {maxWidth: '350px', textTransform: 'capitalize'},
            validation: {
                required: false
            },
            error: 'Selezionare il periodo di competenza per il file pdf'
        },
        daData: {
            elementType: 'select',
            elementConfig: {
                options: [],
                disabled: false
            },
            value: '',
            label: 'Da:',
            valid: false,
            touched: false,
            cssClass: 'col-12 col-sm-12 col-md-4 col-lg-2',
            style: {maxWidth: '350px', textTransform: 'capitalize'},
            validation: {
                required: false
            },
            error: 'Selezionare il periodo di competenza per il file pdf'
        },
        aData: {
            elementType: 'select',
            elementConfig: {
                options: [],
                disabled: false
            },
            value: '',
            label: 'A:',
            valid: false,
            touched: false,
            cssClass: 'col-12 col-sm-12 col-md-4 col-lg-2',
            style: {maxWidth: '350px', textTransform: 'capitalize'},
            validation: {
                required: false
            },
            error: 'Selezionare il periodo di competenza per il castelletto'
        }
    }
};

